module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-lo"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "lo-modal-title"
  }, [_vm._v("HOÀN THÀNH BÀI TẬP")]), _c('span', {
    staticClass: "lo-modal-btn-close material-icons",
    on: {
      "click": _vm.closePopupFinish
    }
  }, [_vm._v("close")])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "reg-content"
  }, [_vm._v("Bạn đã hoàn thành bài tập, nội dung làm bài của bạn sẽ được gửi về giáo viên này. "), (!_vm.fromClass) ? _c('abbr', [_vm._v("Tham gia các lớp học của giáo viên để tiếp cận nhiều bài tập hay hơn nữa:")]) : _vm._e()])]), _c('div', {
    staticClass: "modal-footer lo-custom-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-12 text-center"
  }, [(!_vm.fromClass) ? _c('a', {
    staticClass: "lo-btn-continue lo-popup-pc btn",
    on: {
      "click": _vm.continuteTeacherFinish
    }
  }, [_vm._v("Lớp học của giáo viên")]) : _c('a', {
    staticClass: "lo-btn-continue lo-popup-pc btn",
    on: {
      "click": _vm.continuteTeacherFinish
    }
  }, [_vm._v("Xác nhận")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76fa62d2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Front/LandingPage/Exercise/popup.vue
// module id = 1611
// module chunks = 0